
<template>

  <svg viewBox="0 0 39.8 26.5" aria-hidden="true">

    <g transform="translate(-82.1 -114)">

      <g stroke="currentColor" stroke-width="1.01" fill="none" >

        <g>

          <path d="m88.4 121 6.96-1.59 6.96 1.59 6.71-1.59 6.71 1.59 5.38 19-9.44-2.74-9.44 2.74-9.7-2.74-9.7 2.74z" />

          <path d="m92.5 137 2.82-17.8" />

          <path d="m109 119 2.65 17.8" />

          <path d="m102 140 0.0854-19" />

        </g>

        <path d="m117 127c-11-0.224-29.8 2.74-34.5 13.2" />

        <path d="m95.7 130c8.76 5.52 16.6 6.52 24.3 6.15" />

      </g>

      <path d="m105 114c-1.72 0-3.12 1.4-3.12 3.12 0 1.72 3.12 8.9 3.12 8.9s3.12-7.17 3.12-8.9c0-1.72-1.4-3.12-3.12-3.12zm0 1.54c0.873 0 1.58 0.708 1.58 1.58 0 0.873-0.708 1.58-1.58 1.58-0.873 0-1.58-0.708-1.58-1.58 0-0.873 0.708-1.58 1.58-1.58z"
      
        fill="currentColor" />

    </g>

  </svg>

</template>
